module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/images/shop_iron_age_bg.47772bd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/images/shop_iron_age_bg.jpg
// module id = 1319
// module chunks = 16